import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import Iconmoon from '@deprecated-ui/common/Iconmoon';
import color from '@deprecated-ui/_style/color';
import Image from 'global/Image';
import { CSSProperties } from 'react';
import ReceiverItemAvatar from './SearchReceiver/ReceiverItemAvatar';
import { IconMedia, AvatarWrapper, SelectedIconWrapper } from './styled';

interface SectionItemProps {
  caption: string;
  src: string;
  background?: string;
  onClick: () => void;
  selected?: boolean;
  bordered?: boolean;
  isAvatar?: boolean;
  data?: any;
  imageStyle?: CSSProperties;
}

function SectionItem({
  caption,
  src,
  background,
  onClick,
  selected = false,
  bordered,
  isAvatar,
  data,
  imageStyle,
}: SectionItemProps) {
  return (
    <Flex width="20%" direction="column" align="center">
      <div style={{ position: 'relative' }}>
        {isAvatar ? (
          <>
            <AvatarWrapper role="button" onClick={onClick} selected={selected}>
              <ReceiverItemAvatar
                name={data?.name}
                shortName={data?.shortName}
                src={data?.avatar}
                type={data.type}
              />
            </AvatarWrapper>
          </>
        ) : (
          <IconMedia
            background={background}
            onClick={onClick}
            // @ts-expect-error
            selected={selected}
            bordered={bordered}
          >
            <Image
              alt={caption}
              src={src}
              style={imageStyle}
            />
          </IconMedia>
        )}
        {selected && (
          <SelectedIconWrapper>
            <Iconmoon className="icon-toolbar_check" color={color.light} />
          </SelectedIconWrapper>
        )}
      </div>
      <Text size="11px" ellipsis>
        {caption.length > 11 ? `${caption.slice(0, 11)}...` : caption}
      </Text>
    </Flex>
  );
}

export default SectionItem;
